import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators,FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/providers/alert.service';
import { ApiService } from 'src/app/providers/api.service';
import { AuthService } from 'src/app/providers/auth.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { StorageService } from 'src/app/providers/storage.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { COUNTRY_CODES } from 'src/app/shared/data/country-codes';

@Component({
  selector: 'sm-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
  @ViewChild('submitButton', {read: ElementRef ,static: true})
  submitButton!: ElementRef<HTMLButtonElement>;
  signInForm!: FormGroup;
  countryList: {name: string; dial_code: string; code: string; flag: string; preferred?: any;}[] = COUNTRY_CODES;
  countryCode: FormControl;
  phoneControl: FormControl;
  sendingOtpStatus: boolean = false;
  otpReceived: boolean = false;
  cinput: any = ''
  private _apiSubscription: Subscription;
  searchString: FormControl = new FormControl('');

  constructor(
    private _navService: NavigationService,
    private _router: Router,
    private _authService: AuthService,
    private _alertService: AlertService,
    private _apiService: ApiService,
    private _storageService: StorageService
  ) {
    this._navService.hideSidebarAndNav = true;
    this.countryCode = new FormControl(this.countryList.find(country => country.dial_code === '+91'), Validators.required);
    this.phoneControl = new FormControl('', [Validators.required, Validators.minLength(10)]);

    this._apiSubscription = this._apiService.apiResult.subscribe(resData => {
      if (resData.responseType === SM_CONSTANTS.CHECK_USER_RESULT) {
        console.log(resData);
        if(resData.result){
          this._storageService.setLocalStorageValue(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER, this.userPhoneNumber)
        
        if (resData.result.errorcode === 1) {
          this._storageService.setLocalStorageValue(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID, resData.result.accountHashID);
          this._router.navigateByUrl('/dashboard').then(_ => {
            this._alertService.onOpenSnackbar('Logged in successfully');
          });
          this.sendingOtpStatus = false;
        } 
        else if(resData.result.errorcode === 0){
          this._storageService.setLocalStorageValue(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID, resData.result.accountHashID);
          this._router.navigate(["/registration"])
          this.sendingOtpStatus = false;
        } 
        else {
          this._alertService.onOpenSnackbar(resData.result.message, 4000);
          this.sendingOtpStatus = false;

        }
      }
      }
    });
  }

  onKey() { 
    console.log(this.searchString.value);
    
    this.countryList= []; 
    this.selectSearch(this.searchString.value);       
}

onCountrySelected(event: any): void {
  this.searchString.reset()
  this.countryList = COUNTRY_CODES
}

onSelectOpened(opened: boolean): void {
  const panel = document.querySelector('.mat-select-panel') as HTMLElement;
  const fixedPanel = document.querySelector('.mat-select-panel-fixed') as HTMLElement;

  if (panel && fixedPanel) {
    if (opened) {
      fixedPanel.style.display = 'block';
      panel.classList.add('mat-select-panel-fixed');
    } else {
      fixedPanel.style.display = 'none';
      panel.classList.remove('mat-select-panel-fixed');
    }
  }
}


selectSearch(value:string){
  let filter = value.toLowerCase();
  for ( let i = 0 ; i < COUNTRY_CODES.length; i ++ ) {
      let option = COUNTRY_CODES[i];
      if (  option.name.toLowerCase().indexOf(filter) >= 0) {
          this.countryList.push( option );
      }
  }
}

  ngOnInit(): void {
    this.signInForm = new FormGroup({
      'country': this.countryCode,
      'phone': this.phoneControl,
      'otp': new FormControl('', [Validators.required, Validators.minLength(6)])
    });
    this._authService.initRecaptcha(this.submitButton.nativeElement)
  }

  


  onSendOTP(){
    console.log(this.userPhoneNumber);
    this.sendingOtpStatus = true;
    this._authService.onReceiveOTP(this.userPhoneNumber).then(res =>{
      this.sendingOtpStatus = !res;
      this.otpReceived = res;
    });
  }

  private get userPhoneNumber(){
    return (this.signInForm.value['country'].dial_code + this.signInForm.value['phone']).toString();
  }
  
  onSignIn(){
    this.sendingOtpStatus = true;
    this._authService.onSignInWithPhone(this.signInForm.value['otp']).then(res =>{
      if(res){
        console.log(res);
        const apiBodyData = {
          versionCode: '1.0.0',
          appType: 'web',
          appName: 'business'
        }
        this._apiService.checkUser(apiBodyData, res.user.uid, this.userPhoneNumber);
        }
    });
  }
  checkUser(){
    this.sendingOtpStatus = true;
    this._authService.check().then(res =>{
      if(res){
        console.log(res);
        // const apiBodyData = {
        //   versionCode: '1.0.0',
        //   appType: 'web'
        // }
        // this._apiService.checkUser(apiBodyData, res.user.uid, this.userPhoneNumber);
        }
    });
  }
  deleteUser(){
    this.sendingOtpStatus = true;
    this._authService.delete().then(res =>{
      if(res){
        console.log(res);
        // const apiBodyData = {
        //   versionCode: '1.0.0',
        //   appType: 'web'
        // }
        // this._apiService.checkUser(apiBodyData, res.user.uid, this.userPhoneNumber);
        }
    });
  }


  ngOnDestroy(){
    this._apiSubscription.unsubscribe();
  }

}
